<template>
  <div class="checkbox-group-field-renderer">
    <p v-if="campo.label" class="checkbox-group-field-renderer__label">
      {{ campo.label }}
    </p>
    <div
      v-for="grupo in gruposDeOpcoes"
      :key="grupo.categoria ?? '__sem-categoria'"
      class="checkbox-group-field-renderer__group"
    >
      <div
        v-if="grupo.categoria"
        class="checkbox-group-field-renderer__category"
      >
        <small>{{ grupo.categoria }}</small>
      </div>
      <label
        v-for="opcao in grupo.opcoes"
        :key="opcao.value"
        class="checkbox-group-field-renderer__option"
      >
        <PCheckbox
          :model-value="isChecked(opcao)"
          @update:model-value="(v: boolean) => toggle(opcao, v)"
        />
        <span>{{ opcao.label }}</span>
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PCheckbox } from "@f360-dev/f360-prisma";
import { computed } from "vue";
import {
  TIntegracaoCampoModel,
  TIntegracaoCampoOpcao
} from "../../../@types/IntegracaoCampoModel";

const props = defineProps<{
  campo: TIntegracaoCampoModel;
  modelValue?: string[] | null;
  error?: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string[]): void;
}>();

const selecionados = computed(() =>
  Array.isArray(props.modelValue) ? props.modelValue : []
);

const gruposDeOpcoes = computed(() => {
  const grupos: {
    categoria: string | null;
    opcoes: TIntegracaoCampoOpcao[];
  }[] = [];

  for (const opcao of props.campo.opcoes ?? []) {
    const categoria = opcao.categoria ?? null;
    const ultimo = grupos[grupos.length - 1];

    if (ultimo && ultimo.categoria === categoria) {
      ultimo.opcoes.push(opcao);
      continue;
    }

    grupos.push({ categoria, opcoes: [opcao] });
  }

  return grupos;
});

const isChecked = (opcao: TIntegracaoCampoOpcao): boolean =>
  selecionados.value.includes(opcao.value);

const toggle = (opcao: TIntegracaoCampoOpcao, checked: boolean) => {
  const next = checked
    ? [...selecionados.value, opcao.value]
    : selecionados.value.filter((value) => value !== opcao.value);

  emit("update:modelValue", next);
};
</script>

<style lang="scss" scoped>
.checkbox-group-field-renderer {
  width: 100%;

  &__label {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 600;
  }

  &__category {
    margin: 12px 0 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--el-border-color-light, #ebeef5);
    color: var(--p-color-text-secondary, #6b7280);
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.02em;
  }

  &__option {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 4px 0;
    font-weight: 400;
    font-size: 13px;
    cursor: pointer;
  }
}
</style>
